module.exports = __webpack_public_path__ + "img/8.cb401069.svg";